module.exports = __webpack_public_path__ + "media/images/icons/institutions_statistics-8b85092eba9290632cb5e24bf5cad134.svg";